import { Component } from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {AnimationOptions, LottieComponent} from "ngx-lottie";

@Component({
  selector: 'app-loader-dialog',
  standalone: true,
  imports: [
    LottieComponent
  ],
  templateUrl: './loader-dialog.component.html',
  styleUrl: './loader-dialog.component.css'
})
export class LoaderDialogComponent {
  options: AnimationOptions = {
    path: '/loader.json',
    loop: true,
    autoplay: true
  };
}
